export default "__VITE_ASSET__BlKcUjc6__"